import { useState, useEffect } from "react";
import { apiService } from "../services/apiService";
import { API_ENDPOINTS } from "../config/api";
import { handleError } from "../utils/errorHandler";
import logo from "../assets/kwike1.png";
import "./navbar.css";
import "./NotificationPanel.css";
import { IoMdNotifications } from "react-icons/io";
import { CgProfile } from "react-icons/cg";
import { Link } from "react-router-dom";
import ThemeSwitch from "./ui/ThemeSwitch";
import NotificationPanel from "./NotificationPanel";

const Navbar = () => {
  const [time, setTime] = useState(new Date().toLocaleTimeString());
  const [panelOpen, setPanelOpen] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date().toLocaleTimeString()), 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const response = await apiService.get(API_ENDPOINTS.notifications.count);
      setNotificationCount(response.count ?? 0);
    } catch (error) {
      handleError(error, {
        context: "Navbar - fetchUnreadCount",
        showToast: false,
      });
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 60_000);
    return () => clearInterval(interval);
  }, []);

  const togglePanel = () => {
    setPanelOpen((open) => !open);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="time-display">{time}</div>
      </div>

      <div className="navbar-center">
        <ThemeSwitch size="sm" className="navbar-theme-switch" />
      </div>

      <div className="navbar-right">
        <div className="notification-container">
          <button
            type="button"
            className="notification-btn"
            onClick={togglePanel}
            aria-label="Notifications"
            aria-expanded={panelOpen}
          >
            <IoMdNotifications size={20} />
            {notificationCount > 0 && (
              <span className="notification-badge">
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            )}
          </button>
          <NotificationPanel
            isOpen={panelOpen}
            onClose={() => setPanelOpen(false)}
            onCountChange={setNotificationCount}
          />
        </div>

        <Link to="/profile" className="profile-link">
          <button type="button" className="profile-btn" aria-label="Profile">
            <CgProfile size={20} />
          </button>
        </Link>

        <div className="logo-container">
          <img src={logo} alt="Company Logo" className="company-logo" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
